<template>
  <div>
    <v-menu
      v-model="localOpenModal"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          v-model="localDate"
          data-cy="DatePicker-input"
          :label="label"
          :rules="rules"
          @click="localOpenModal = true"
          :filled="filled"
          :id="id"
          @click:clear="$emit('input', undefined)"
          @input="offClick"
          :dense="dense"
          v-mask="'####-##-##'"
          ref="dateField"
        />
      </template>
      <v-date-picker
        v-model="UpdatedDate"
        @input="inputDate"
      />
    </v-menu>
  </div>
</template>
<script>
import { mdiCalendar } from '@mdi/js';

export default {
  name: 'DatePickerSmall',
  props: {
    id: {
      type: String,
      default: 'date-picker-small',
    },
    openModal: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: 'White',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Date',
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localOpenModal: this.openModal,
      localDate: this.value,
      UpdatedDate: undefined,
      mdiCalendar,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.setLocalDate();
      },
    },
    localDate() {
      this.$emit('input', this.localDate);
    },
  },
  mounted() {
    this.setLocalDate();
  },
  methods: {
    inputDate(val) {
      this.localOpenModal = false;
      this.localDate = val;
      this.$emit('input', this.localDate);
    },
    setLocalDate() {
      if (this.value?.length > 10) {
        this.localDate = this.value.substring(0, 10);
      } else {
        this.localDate = this.value ?? '';
      }
    },
    offClick() {
      if (this.localDate.length >= 10) {
        this.UpdatedDate = this.localDate;
      }
      this.localOpenModal = false;
    },
  },
};
</script>
